import 'angular:locale/data:es';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "es";
